<!--
 * @Descripttion: 活动弹层
 * @Author: Yang Maoxiang
 * @Date: 2020-08-27 11:25:32
 * @LastEditTime: 2023-12-19 15:53:05
-->
<template>
  <ul class="detail">
    <li
      class="detail-list"
      v-for="(item, index) in ActInfo.filter(item => item.actType != '6')"
      :key="index"
      @click="goDetail(item)"
      role="link"
      tabindex="0"
      :aria-labelledby="`title-${index} tips-${index} desc-${index}`"
    >
      <div class="top" aria-hidden="true">
        <div class="title">
          <img v-lazy="item.actIcon" alt="" />
          <div class="title-content" :id="`title-${index}`">{{ item.actTitle }}</div>
        </div>
        <div class="right" v-if="!env.isPadVivoApp" :id="`desc-${index}`">
          <div class="right-title fs-36" v-if="(item.skipDesc && item.skipLink) || item.actType == 2">
            {{ item.skipDesc }}
          </div>
          <div class="right-icon" v-if="item.skipLink || item.actType == 2"></div>
        </div>
      </div>
      <p class="tips" :id="`tips-${index}`" aria-hidden="true">
        <template v-if="item.actType == 1">
          <div
            v-if="tradeInAcShowPrice && renewPriceActivityPopupLabelAndReward"
            v-html="renewPriceActivityPopupLabelAndReward"
          ></div>
          <div v-else v-html="ActDesc"></div>
        </template>
        <template v-else>
          {{ item.actMemberDesc || item.actDesc }}
        </template>
      </p>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import env from 'utils/clientEnv'
import { app } from '@/utils'

export default {
  name: 'ActivityPopup',
  props: {
    ActInfo: {
      type: Array,
      default: null
    },
    ActDesc: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      env
    }
  },
  computed: {
    ...mapGetters('detailv3', [
      'skuId',
      'renewPriceActivityPopupLabelAndReward',
      'tradeInAcShowPrice',
      'recycleSupplierId'
    ])
  },
  methods: {
    ...mapActions('detailv3', ['showSkuSelect', 'setRecycleIframeParams']),
    goDetail(item) {
      if (this.env.isPadVivoApp) return
      this.$track({
        cfrom: '152|002|01|077',
        event_id: '152|002|01|077',
        page_name: 1,
        sku_id: this.skuId,
        promotion_name: item.actTitle
      })
      if (item.actType == 2) {
        this.$emit('close')
        setTimeout(() => {
          this.showSkuSelect({
            isShow: true,
            params: {
              source: 9,
              isShow: true,
              checked: {
                laser: true
              }
            }
          })
        }, 200)
      } else if (item.actType == 1) {
        this.$emit('close')
        this.$track({
          cfrom: '081|082|01|077',
          event_id: '081|082|01|077',
          activity_type: this.recycleSupplierId ? 2 : 1, //1:通用、2:换新,有供应商id时为换新场景
          sku_id: this.skuId,
          source_type: this.recycleSupplierId //##供应商id
        })
        setTimeout(() => {
          this.$emit('goToRenew', { trackFrom: 3 }, item.skipLink) // 商详页活动弹层
        }, 200)
      } else if (item.skipLink) {
        app.openNewWebview({
          url: item.skipLink
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
